const WelcomeSectionStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '100px 0',
    backgroundColor: 'transparent',
    position: 'relative',
    boxShadow: 'none',
  },
  textContainer: {
    textAlign: 'left',
    maxWidth: '600px',
  },
  title: {
    fontSize: '4.5rem',
    fontWeight: '900',
    color: '#000',
    fontFamily: "'Comic Sans MS', cursive, 'Marker Felt', cursive, sans-serif",
    lineHeight: '1.1',
    textTransform: 'uppercase',
  },
  subtitle: {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: '#81c241',
    fontFamily: "'Comic Sans MS', cursive, 'Marker Felt', cursive, sans-serif",
    textTransform: 'uppercase',
    marginTop: '10px',
    lineHeight: '1.2',
  },
  stepsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    padding: '40px 0',
  },
  timeline: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '50px',
    borderLeft: '4px dashed #000',
    paddingLeft: '30px',
    alignItems: 'center',
  },
  stepContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    position: 'relative',
  },
  timelineItem: {
    position: 'relative',
    width: '20px',
    height: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    left: '-10px',
  },
  stepCircle: {
    width: '14px',
    height: '14px',
    backgroundColor: '#000',
    borderRadius: '50%',
    position: 'relative',
  },
  stepLabelLeft: {
    backgroundColor: '#81c241',
    padding: '6px 12px',
    borderRadius: '5px',
    boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.2)',
    position: 'absolute',
    left: '-150px',
  },
  stepLabelRight: {
    backgroundColor: '#81c241',
    padding: '6px 12px',
    borderRadius: '5px',
    boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.2)',
    position: 'absolute',
    right: '-150px',
  },
  stepLabel: {
    fontWeight: 'bold',
    color: '#fff',
    fontSize: '1rem',
    fontFamily: "'Comic Sans MS', cursive, 'Marker Felt', cursive, sans-serif",
    textTransform: 'uppercase',
  },
  stepTextLeft: {
    maxWidth: '280px',
    textAlign: 'left',
    paddingRight: '20px',
  },
  stepTextRight: {
    maxWidth: '280px',
    textAlign: 'right',
    paddingLeft: '20px',
  },
  stepText: {
    color: '#333',
    fontSize: '1.1rem',
    lineHeight: '1.5',
  },
  growLabelWrapper: {
    backgroundColor: '#81c241',
    padding: '8px 20px',
    borderRadius: '5px',
    boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.3)',
    marginTop: '20px',
  },
  growLabel: {
    fontWeight: 'bold',
    color: '#000',
    fontSize: '1.3rem',
    fontFamily: "'Comic Sans MS', cursive, 'Marker Felt', cursive, sans-serif",
    textTransform: 'uppercase',
  },
};

export default WelcomeSectionStyles;
